import { defineComponent as u, openBlock as t, createElementBlock as a, mergeProps as i, unref as o, renderSlot as g, createElementVNode as e, createCommentVNode as M } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, A = { key: 1 }, L = { key: 2 }, f = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconArrowBendDoubleUpLeft"
}, _ = /* @__PURE__ */ u({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (p, l) => (t(), a("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, o(d)), [
      g(p.$slots, "default"),
      o(n) === "bold" ? (t(), a("g", m, l[0] || (l[0] = [
        e("path", { d: "M88.49,143.51a12,12,0,0,1-17,17l-48-48a12,12,0,0,1,0-17l48-48a12,12,0,0,1,17,17L49,104ZM128,92H117l27.52-27.52a12,12,0,0,0-17-17l-48,48a12,12,0,0,0,0,17l48,48a12,12,0,0,0,17-17L117,116h11a84.09,84.09,0,0,1,84,84,12,12,0,0,0,24,0A108.12,108.12,0,0,0,128,92Z" }, null, -1)
      ]))) : o(n) === "duotone" ? (t(), a("g", A, l[1] || (l[1] = [
        e("path", {
          d: "M128,56v96L80,104Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M85.66,146.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L43.31,104ZM232,200a8,8,0,0,1-16,0,88.11,88.11,0,0,0-80-87.63V152a8,8,0,0,1-13.66,5.66l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,136,56V96.3A104.15,104.15,0,0,1,232,200ZM120,75.31,91.31,104,120,132.69Z" }, null, -1)
      ]))) : o(n) === "fill" ? (t(), a("g", L, l[2] || (l[2] = [
        e("path", { d: "M85.66,146.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L43.31,104ZM136,96.3V56a8,8,0,0,0-13.66-5.66l-48,48a8,8,0,0,0,0,11.32l48,48A8,8,0,0,0,136,152V112.37A88.11,88.11,0,0,1,216,200a8,8,0,0,0,16,0A104.15,104.15,0,0,0,136,96.3Z" }, null, -1)
      ]))) : o(n) === "light" ? (t(), a("g", f, l[3] || (l[3] = [
        e("path", { d: "M84.24,147.76a6,6,0,1,1-8.48,8.48l-48-48a6,6,0,0,1,0-8.48l48-48a6,6,0,0,1,8.48,8.48L40.49,104ZM128,98H94.49l37.75-37.76a6,6,0,0,0-8.48-8.48l-48,48a6,6,0,0,0,0,8.48l48,48a6,6,0,0,0,8.48-8.48L94.49,110H128a90.1,90.1,0,0,1,90,90,6,6,0,0,0,12,0A102.12,102.12,0,0,0,128,98Z" }, null, -1)
      ]))) : o(n) === "regular" ? (t(), a("g", h, l[4] || (l[4] = [
        e("path", { d: "M85.66,146.34a8,8,0,0,1-11.32,11.32l-48-48a8,8,0,0,1,0-11.32l48-48A8,8,0,0,1,85.66,61.66L43.31,104ZM128,96H99.31l34.35-34.34a8,8,0,0,0-11.32-11.32l-48,48a8,8,0,0,0,0,11.32l48,48a8,8,0,0,0,11.32-11.32L99.31,112H128a88.1,88.1,0,0,1,88,88,8,8,0,0,0,16,0A104.11,104.11,0,0,0,128,96Z" }, null, -1)
      ]))) : o(n) === "thin" ? (t(), a("g", k, l[5] || (l[5] = [
        e("path", { d: "M82.83,149.17a4,4,0,0,1-5.66,5.66l-48-48a4,4,0,0,1,0-5.66l48-48a4,4,0,0,1,5.66,5.66L37.66,104ZM128,100H89.66l41.17-41.17a4,4,0,0,0-5.66-5.66l-48,48a4,4,0,0,0,0,5.66l48,48a4,4,0,0,0,5.66-5.66L89.66,108H128a92.1,92.1,0,0,1,92,92,4,4,0,0,0,8,0A100.11,100.11,0,0,0,128,100Z" }, null, -1)
      ]))) : M("", !0)
    ], 16));
  }
});
export {
  _ as default
};
